export { default } from './svg/logic-branch.svg';
